import api from 'src/config/api';
import {
	IGetSiteAccessesRequestParams,
	IGetSiteAccessesShortInfoRequestParams,
	ISiteAccess,
	ISiteAccessShortInfo,
	IUpdateSiteAccessRequestBody,
} from 'src/features/site_access/domain/types';
import { ICreateSiteAccessFormData } from 'src/features/site_access/domain/types';
import { IUserOption } from 'src/features/user';

export const siteAccessApi = {
	getSiteAccesses: async (
		requestParams: IGetSiteAccessesRequestParams,
		siteSlug: string,
	): Promise<IPaginatedResponse<ISiteAccess>> => {
		const { page = 1, search, sort, order, type, status } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(search && { search }),
			...(sort && order && { sort, order }),
			...(type && { type }),
			...(status && { status }),
		});

		const response = await api.get(`/api/v1/site/accesses?${params}`, {
			headers: {
				Site: siteSlug,
			},
		});

		return response.data;
	},

	createSiteAccess: async (
		requestBody: ICreateSiteAccessFormData,
		siteSlug: string,
	): Promise<ISiteAccess> => {
		const response = await api.post(`/api/v1/site/access`, requestBody, {
			headers: {
				Site: siteSlug,
			},
		});

		return response.data;
	},

	getPatientCreatorsInSite: async (
		siteSlug: string,
	): Promise<IUserOption[]> => {
		const response = await api.get(`/api/v1/site/access/patient-creators`, {
			headers: {
				Site: siteSlug,
			},
		});

		return response.data;
	},

	updateSiteAccess: async (
		requestBody: IUpdateSiteAccessRequestBody,
		siteSlug: string,
		siteAccessId: number,
	): Promise<ISiteAccess> => {
		const response = await api.patch(
			`/api/v1/site/access/${siteAccessId}`,
			requestBody,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);

		return response.data;
	},

	getSiteAccessesShortInfo: async (
		siteSlug: string,
		requestParams: IGetSiteAccessesShortInfoRequestParams,
	): Promise<ISiteAccessShortInfo[]> => {
		const { role } = requestParams;

		const params = new URLSearchParams({
			...(role && { role }),
		});

		const response = await api.get(
			`/api/v1/site/accesses/short-info?${params}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);

		return response.data;
	},
};
